/* import __COLOCATED_TEMPLATE__ from './select-editor.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-component-inheritance */
import { computed, action } from '@ember/object';
import { map } from '@ember/object/computed';
import BaseEditor from './base-editor';
export default BaseEditor.extend({
  predicateOptions: map('predicate.options', function (option) {
    return Object.assign({}, option, {
      text: option.label
    });
  }),
  hasFilter: computed('predicateOptions', 'predicateOptions.length', function () {
    if (!this.predicateOptions) {
      return false;
    }
    if (this.predicateOptions[0]['heading'] !== undefined) {
      return this.predicateOptions.map(option => option.items.length).reduce((sum, current) => sum + current, 0) > 10;
    } else {
      return this.predicateOptions.length > 10;
    }
  }),
  shouldPresentOptions: computed('predicate.comparison', function () {
    let comparison = this.get('predicate.comparison');
    return this._shouldPresentOptions(comparison);
  }),
  changeValue: action(function (value) {
    this.changePredicateValue(value);
  }),
  changePredicateComparisonAction: action(function (value) {
    let wasPresentingOptions = this._shouldPresentOptions(this.predicate.comparison);
    let willPresentOptions = this._shouldPresentOptions(value);
    if (wasPresentingOptions !== willPresentOptions) {
      this.predicate.changeValue(this.predicate.getDefaultValue());
    }
    this.changePredicateComparison(value);
  }),
  _shouldPresentOptions(comparison) {
    return !this.comparisonOptions.findBy('value', comparison)?.ignoreOptions;
  }
});